import { render } from "./wage-positions.vue?vue&type=template&id=6f8ed958"
import script from "./wage-positions.vue?vue&type=script&lang=js"
export * from "./wage-positions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f8ed958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f8ed958', __exports__)) {
    api.reload('6f8ed958', __exports__)
  }
  
  module.hot.accept("./wage-positions.vue?vue&type=template&id=6f8ed958", () => {
    api.rerender('6f8ed958', render)
  })

}


export default __exports__